import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.currentComponent), {
      onOpenBox: _ctx.handleOpenBox,
      onCloseBox: _ctx.handleCloseBox
    }, null, 40, ["onOpenBox", "onCloseBox"]))
  ]))
}